import {
  ALL_EVENTS,
  EVENT_BY_ID,
  EVENT_TYPES,
  INTEGRATION_SUMMARY,
  NOTIFICATION_SETTINGS,
  PAST_EVENTS,
  UPCOMING_EVENTS,
} from "../actionType/calendarType";
import { LOADING } from "../actionType/importType";

const initialState = {
  loading: false,
  eventTypes: [],
  eventById: null,
  allEvents: [],
  upcomingEvents: [],
  pastEvents: [],
  notificationSettings: null,
  integrationSummary: [],
};

const calendarReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case NOTIFICATION_SETTINGS:
      return { ...state, notificationSettings: payload };
    case UPCOMING_EVENTS:
      return { ...state, upcomingEvents: payload };
    case PAST_EVENTS:
      return { ...state, pastEvents: payload };
    case ALL_EVENTS:
      return { ...state, allEvents: payload };
    case EVENT_BY_ID:
      return { ...state, eventById: payload };
    case EVENT_TYPES:
      return { ...state, eventTypes: payload };
    case INTEGRATION_SUMMARY:
      return { ...state, integrationSummary: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default calendarReducer;
